/* @ngInject */
export default function ($scope, LayoutService, TrainingCourses, toastr, $state) {
	$scope.course = {
		name:      '',
		available: true,
		sort:      0,
	};

	LayoutService.setTitle([
		'New Course',
		'Management',
		'Training',
	]);

	LayoutService.getPageHeader()
	             .setActionButton('<button type="button" class="btn btn-primary pull-right"><i class="fa fa-check"></i> Save</button>');

	LayoutService.getPageHeader()
	             .setBreadcrumbs([
		             {
			             route:       'staff.dashboard',
			             displayName: 'Dashboard',
		             },
		             {
			             route:       'staff.training.root',
			             displayName: 'Training',
		             },
		             {
			             route:       'staff.training.management.root',
			             displayName: 'Management',
		             },
		             {
			             route:       'staff.training.management.new',
			             displayName: 'New Course',
		             },
	             ]);

	$scope.save = () => {
		const course = {
			name:      $scope.course.name,
			available: $scope.course.available,
			sort:      $scope.course.sort,
		};

		TrainingCourses.post(course)
		               .then((returnedCourse) => {
			               toastr.clear();
			               toastr.success('The course was successfully created.', 'Course Created');

			               $state.go('staff.training.management.root');
		               })
		               .catch((error) => {
			               toastr.clear();
			               toastr.error('There was an error while creating the course, please try again.', 'Error');
		               });
	};

	LayoutService.getPageHeader()
	             .onClicked($scope.save);
};


// WEBPACK FOOTER //
// ./src/js/endpoints/staff/training/management/new/controller.js